import SegmentedControl from "@react-native-segmented-control/segmented-control";
import { t } from "i18next";

import { useAppTheme } from "@/hooks/useAppTheme";
import { I18nKeyType } from "@/i18n";
import { PRIMARY_FONT } from "@/theme/fonts";
import { cn } from "@/utils/tailwind";

import { VnBox } from "./VnBox";

type VnSegmentedControlPropsType<T> = {
  value: T;
  options: {
    i18nKey: I18nKeyType;
    i18nOptions?: Record<string, unknown>;
    value: T;
  }[];
  onChange: (value: T) => void;
  className?: string;
};

export const VnSegmentedControl = <T,>({
  value,
  options,
  onChange,
  className,
}: VnSegmentedControlPropsType<T>) => {
  const { resolvedColors, isDarkMode } = useAppTheme();

  return (
    <VnBox
      className={cn(
        "dark:bg-muted rounded-full bg-black/5 p-[3px]",
        className,
      )}>
      <SegmentedControl
        fontStyle={{
          color: resolvedColors.mutedForeground,
          fontFamily: PRIMARY_FONT.MEDIUM,
          fontSize: 14,
        }}
        activeFontStyle={{
          color: isDarkMode
            ? resolvedColors.background
            : resolvedColors.foreground,
          fontFamily: PRIMARY_FONT.MEDIUM,
          fontWeight: "500",
          fontSize: 14,
        }}
        sliderStyle={{
          backgroundColor: isDarkMode
            ? resolvedColors.primary
            : resolvedColors.chartOne,
          borderRadius: 9999,
        }}
        style={{
          height: 30,
          borderRadius: 9999,
        }}
        backgroundColor="transparent"
        values={options.map(option => t(option.i18nKey, option.i18nOptions))}
        selectedIndex={options.findIndex(option => option.value === value)}
        onChange={event => {
          const selectedValue =
            options[event.nativeEvent.selectedSegmentIndex]!.value;
          onChange(selectedValue);
        }}
      />
    </VnBox>
  );
};
